export class SubFamiliaId {
    codigoSubFamilia: number;
    codigoFamilia: number;
}